import { getEnv } from '@shared/utils/env';

const EVENT_URL = `${getEnv().VITE_API_URL}/api/v1/corresponsal/events`;

export const getClientURL = (clientId: string) => {
  return `${EVENT_URL}/?clientId=${clientId}`;
};
